



























import { computed, defineComponent, Ref, toRef } from "@vue/composition-api";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import { getMediaDuration } from "@scrile/tools/dist/lib/TimeHelpers";
import { isVideoFile } from "@/lib/fileHelpers";
import { getMediaThumbnailUrl } from "@/lib/urlHelpers";
import { BlockingStatus } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import MessageMediaItemStatus from "./MessageMediaItemStatus.vue";

const useDuration = (attachments: Ref<MessageAttachment[]>) => {
  const showDuration = computed<boolean>(() => {
    if (attachments.value.length === 1) {
      const hasDuration = !isNaN(Number(attachments.value[0].file.metadata.duration));
      return hasDuration && isVideoFile(attachments.value[0].file);
    }
    return false;
  });

  const videoDuration = computed<string>(() => {
    return getMediaDuration(Number(attachments.value[0].file.metadata.duration));
  });

  return { showDuration, videoDuration };
};

export default defineComponent({
  name: "MessageGalleryLocked",
  components: { MessageMediaItemStatus, BaseIcon },
  props: {
    lockedAttachments: { type: Array as () => MessageAttachment[], required: true },
    price: { type: String, required: true },
    isAuthor: { type: Boolean, required: true },
    showBlur: { type: Boolean, default: false },
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
  },
  setup(props) {
    const count = computed(() => props.lockedAttachments.length);

    const attachment = computed(() => {
      const errorAttachment = props.lockedAttachments.find(f => f.file.processingStatus === "ERROR");
      return errorAttachment ? errorAttachment : props.lockedAttachments.find(f => !!f.file);
    });

    const converging = computed(() => attachment.value?.file.processingStatus !== "OK");
    const src = computed(() => {
      return (
        (attachment.value && getMediaThumbnailUrl(attachment.value.file, attachment.value.file.urlPart, "1080p")) || ""
      );
    });

    const { showDuration, videoDuration } = useDuration(toRef(props, "lockedAttachments"));

    return {
      count,
      attachment,
      src,
      converging,
      showDuration,
      videoDuration,
    };
  },
});
